import { useCIQQuery } from "hooks/ciq-gql-hooks";
import { GET_FEATURES_DATA_BY_IDS_FOR_REQUEST_DURATION } from "services/graphQL/ciq-queries";
import { useContext, useMemo } from "react";
import { ProjectContext } from "context/ProjectProvider";
import { IMaterial } from "../type-definitions";

function formatNewModel(newModelData: any) {
  if (!newModelData) return null;

  const featuresInOldModelFormat: any[] = newModelData.feature_instance.map(
    (feature: any) => {
      const featureObjInOldModelFormat = {
        id: feature.id,
        name: feature.name,
        assignee: feature.material_assignee?.[0]?.user?.id,
        estimate_invite_features: feature.estimate_invite_features,
        material_assignee: feature.material_assignee?.[0]?.user,
        trade_partner: feature.materials_trade_partner?.[0]?.vendor?.id,
        materials_trade_partner: feature.materials_trade_partner?.[0]?.vendor,
        assignee_unregistered:
          feature.material_assignee?.[0]?.user_unregistered,
        status: feature.feature_materials?.[0]?.status,
        date_block_materials: [feature.feature_workflow_instance]
      };
      return featureObjInOldModelFormat;
    }
  );

  return {
    material: featuresInOldModelFormat
  };
}

function useRequestDurationsOldNewModelDataProvider(selectedIds: string[]) {
  const { gqlClientForProject } = useContext(ProjectContext);

  const { data: newModelData, loading } = useCIQQuery<{
    material: IMaterial[];
  }>(GET_FEATURES_DATA_BY_IDS_FOR_REQUEST_DURATION, {
    client: gqlClientForProject,
    variables: {
      featureIds: selectedIds
    }
  });

  const data = useMemo(() => formatNewModel(newModelData), [newModelData]);

  return { data, loading };
}

export default useRequestDurationsOldNewModelDataProvider;
